/**
 * Created by d.lolua on 12/4/2017.
 */
export const mapToOptionsCategory = (data = []) => {
    return data.map(item => ({ value: item.id, label: item.name }));
};
export const mapToOptions = (data = []) => {
    return data.map(item => ({ value: item.id, label: item.name }));
};



// WEBPACK FOOTER //
// ./src/utils/index.js